module.exports = __webpack_public_path__ + "static/media/quidditch.7c2a5616.svg";